import { useState, useMemo, useEffect } from 'react';
import { useSelector } from 'react-redux';
import ChatSearchBar from './ChatSearchBar';
import ChatListItem from './ChatListItem';
import { Loader2 } from 'lucide-react';

function ChatsListMobile({ onChatSelect }) {
  const chats = useSelector((s) => s.chats.chats);
  const [chatsArray, setChatsArray] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [searchLoading, setSearchLoading] = useState(false);

  const chatsList = useMemo(() => Object.values(chats), [chats]);

  // Sync chatsArray with chatsList when not searching (for realtime updates)
  useEffect(() => {
    if (!searchQuery.trim()) {
      setChatsArray(chatsList);
    }
  }, [chatsList, searchQuery]);

  if (chatsList.length === 0) {
    return (
      <div className="flex h-full items-center justify-center p-6 text-center text-sm text-muted-foreground">
        No conversations yet. Match with someone to start chatting.
      </div>
    );
  }

  return (
    <div className="h-full overflow-y-auto">
      <ChatSearchBar 
        chats={chatsList} 
        searchQuery={searchQuery}
        onSearchQueryChange={setSearchQuery}
        onFiltered={setChatsArray} 
        onSearchLoading={setSearchLoading} 
      />
      <ul className="m-0 list-none p-0">
        {searchLoading && (
          <li className="flex items-center gap-2 px-4 py-3 text-sm text-muted-foreground">
            <Loader2 className="h-4 w-4 animate-spin" />
            Loading...
          </li>
        )}
        {chatsArray.map((c) => <ChatListItem key={c.id} chat={c} onChatSelect={onChatSelect} />)}
      </ul>
    </div>
  );
}

export default ChatsListMobile;
